export const ListQueryKey = 'projects';
export const DetailQueryKey = 'project';
export const Urls = {
  selectUrl: '/project/list',
  updateUrl: '/project/update',
  deleteUrl: '/project/delete',
  createUrl: '/project/create',
  detailUrl: '/project/detail'
};